// This filter removes any parentheses and whitespaces from phone number and prepend country code.
export default value => {
  // for turkey phone numbers
  if (import.meta.env.VITE_COUNTRY === 'tr') {
    return (
      value.slice(0, 2) +
      ' (' +
      value.slice(2, 5) +
      ') ' +
      value.slice(5, 8) +
      ' ' +
      value.slice(8, 10) +
      ' ' +
      value.slice(10, 12)
    )
  }

  // for romania phone numbers
  return value.slice(0, 2) + ' (' + value.slice(2, 5) + ') ' + value.slice(5, 8) + ' ' + value.slice(8, 11)
}
